var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContrasea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4377 8.75948H18.2552V7.2516C18.2552 6.07794 17.7794 5.01439 17.0093 4.2462C16.2391 3.47542 15.1747 3 14 3C11.6507 3 9.74477 4.90299 9.74477 7.2516V8.75948H8.56233C7.69883 8.75948 7 9.45772 7 10.3205V19.439C7 20.3018 7.69883 21 8.56233 21H19.4377C20.3012 21 21 20.3018 21 19.439V10.3205C21 9.45772 20.3012 8.75948 19.4377 8.75948ZM14.7572 15.5955V17.0515C14.7572 17.2601 14.6729 17.4492 14.5355 17.5865C14.398 17.7239 14.2087 17.8081 14 17.8081C13.5825 17.8081 13.2428 17.47 13.2428 17.0515V15.6058C12.8448 15.3571 12.5803 14.9141 12.5803 14.4101C12.5803 13.6316 13.2117 13.0007 13.9909 13.0007C14.7701 13.0007 15.4016 13.6316 15.4016 14.4101C15.4029 14.9076 15.1461 15.3442 14.7572 15.5955ZM16.4958 8.75948H11.5042V7.2516C11.5042 6.58575 11.7635 5.95876 12.2354 5.48852C12.7074 5.01698 13.3336 4.7579 14 4.7579C14.6664 4.7579 15.2939 5.01698 15.7646 5.48852C16.2365 5.96006 16.4958 6.58575 16.4958 7.2516V8.75948Z",
    fill: "#52596B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrasea);
export default __webpack_public_path__ + "static/media/contraseña.3a5e6b580c2935dce9da07aae44e9eb5.svg";
export { ForwardRef as ReactComponent };